var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('a-table',{attrs:{"columns":_vm.columns,"rowKey":"id","size":"small","rowClassName":_vm.getRowClassName,"pagination":{pageSize: 50},"dataSource":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }